import React, { createContext, useState, useEffect } from "react";
import Pusher from "pusher-js";

export const NotificationContext = createContext();

const getUserId = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  return user ? user.id : null;
};

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const userId = getUserId(); // Get user ID from localStorage

  useEffect(() => {
    if (!userId) return; // Don't subscribe if userId is not available

    const pusher = new Pusher("aebc2eec94386d5d25a3", {
      cluster: "mt1",
      forceTLS: true,
    });

    const globalChannel = pusher.subscribe("global.notifications");
    globalChannel.bind("NotificationCreated", (data) => {
      // Handle global notifications
      showNotification(data);
      setNotifications((prev) => [...prev, data]);
    });

    const userChannel = pusher.subscribe(`NotificationByUser.${userId}.notifications`);
    userChannel.bind("NotificationByUser", (data) => {
      // Handle user-specific notifications
      showNotification(data);
      setNotifications((prev) => [...prev, data]);
    });

    return () => {
      globalChannel.unbind_all();
      globalChannel.unsubscribe();
      userChannel.unbind_all();
      userChannel.unsubscribe();
      pusher.disconnect();
    };
  }, [userId]);

  const showNotification = (data) => {
    if (navigator.serviceWorker.controller) {
      navigator.serviceWorker.controller.postMessage({
        type: 'SHOW_NOTIFICATION',
        title: data.title,
        options: {
          body: data.message,
          icon: "/icon.png",
          badge: "/badge.png",
          data: { url: data.url }
        }
      });
    }
  };

  return (
    <NotificationContext.Provider value={notifications}>
      {children}
    </NotificationContext.Provider>
  );
};
